<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
// import Loader from "@/components/widgets/preloader";
import { mapGetters,mapActions,mapState } from "vuex"
// import Swal from "sweetalert2";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Invoice Details",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    // ModelListSelect,
    // Loader,
  },
  data() {
    return {
      title: "Invoice Details",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Invoices",
          active: true,
        },
      ],
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",
    
      data:{
        id: atob(this.$route.params.id),
      },

      switchstatus: 1,

    };
  },
  computed: {
         // MAP STATE
    ...mapState("notification", [
      "type",
      "message",
      "show",
      ]),
    ...mapGetters("invoices", ["Invoice","SaveStatus"]),
    ...mapGetters("setting", ["PaymentOptions","ReceiptSettings"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.Invoice ? this.Invoice.length : 1;
    },
    

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.Invoice ? this.Invoice.length : 1;
  },
  updated() {
    
  },
 
  methods: {
    ...mapActions({
      FetchInvoice: "invoices/fetchInvoice",
      fetchReceiptSettings: "setting/fetchReceiptSettings",
      FetchModes: "setting/fetchPaymentOptions",
      
    }),
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    onFiltered1(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows1 = filteredItems.length;
      this.currentPage1 = 1;
    },
    // COMMA SEPERATORS
    thousandSeperator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
            .toString()
            .replace(/\D/g, "")
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },

    UpdateSetting(id, status){      
      let activeoption = this.PaymentOptions.filter((item)=>{
            return item.id == id;
      });       
      if(status==0){
        activeoption[0].showstatus = 1;
      }else if(status==1){      
        activeoption[0].showstatus = 0;
      }   
    }
  },
  created() {
    this.FetchInvoice(this.data);
    this.fetchReceiptSettings();
    this.FetchModes();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row mt-5 px-5" v-if="Invoice">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="invoice-title">
              <!-- <center> -->
              <div class="row">
                <div class="col-2">
                  <div class="d-print-none">
                    <div class="float-end">
                      <a
                        href="javascript:window.print()"
                        class="btn btn-success waves-effect waves-light me-1"
                        ><i class="fa fa-print"></i
                      > Print</a>                        
                    </div>
                  </div>
                </div>
                <div class="col-3" align="center">
                  <img v-if="Invoice.business.Businesslogo" :src="Invoice?Invoice.business.Businesslogo:''" height="80" /> 
                </div>
                <div class="col-5 text-center">
                  <span class=" font-size-20 text-uppercase text-success"><strong>{{Invoice ? Invoice.business.name : ''}}</strong></span><br/>
                  <span class=" font-size-18"><strong class="text-danger">Location:</strong> <b>{{Invoice ? Invoice.branch.address : ''}}</b></span><br/>
                  <span class=" font-size-18"><strong class="text-danger">Tel:</strong> <b>{{Invoice?Invoice.branch.phone1: ''}}</b></span><br/>
                  <span class=" font-size-18" v-if="Invoice && Invoice.branch.email"><strong class="text-danger">Email:</strong> <b>{{Invoice ? Invoice.branch.email : "---"}}</b></span><br/>
                </div>
                <div class="col-2 d-print-none">
                    <b-button @click="$router.go(-1)" variant="warning"><i class="fa fa-undo"></i> Back</b-button>
                </div>
              </div>
              <div class="mb-4">
              </div>
            </div>
            <div style="border-top: 1px solid black;"></div>
            <div class="font-size-16 text-center py-3"><b>CUSTOMER INVOICE</b></div>
            <div class="row font-size-15 py-3">
              <div class="col-6">
                <address>
                  <strong>Customer:</strong>
                 {{ Invoice?Invoice.customer.name:'' }} <br />
                </address>
              </div>
              <div class="col-6">
                <address>
                  <strong>Date:</strong>
                   :{{Invoice.date}} <br />
                   <strong>Invoice Number:</strong>  {{ Invoice?Invoice.invoice_number:'' }} 
                </address>
              </div>
            
            </div>
            
            <div style="border-top: 1px solid black;"></div>
            <div class="p-2 mt-0">
              <h3 class="font-size-16">Invoice Items</h3>
            </div>
            <div>
              <table class="table font-size-15">
                <thead>
                  <tr>
                    <th style="width: 70px">No.</th>
                    <th>Product</th>
                    <th>Quantity</th>
                    <th class="text-sm-end">Price</th>
                    <th class="text-sm-end">Total</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(pdt, index) in Invoice?Invoice.items:'---'" :key="index">
                    <td>{{ index+1 }}</td>
                    <td>{{pdt.product}}</td>
                    <td>{{pdt.qty}} {{pdt.unit}}</td>
                    <td class="text-sm-end">{{pdt.price.toLocaleString()}}</td>
                    <td class="text-sm-end">{{pdt.total}}</td>
                  </tr>
                </tbody>
              </table>
              <div class="row">
                <div class="col-4 text-center">
                  <h5 class="m-0">Total:  {{Invoice ? Invoice.business.currency.currency_code : ""}} {{ Invoice?Invoice.total.toLocaleString():0}}</h5>
                </div>
                <div class="col-4 text-center">
                  <h5 class="m-0">Paid:  {{Invoice ? Invoice.business.currency.currency_code : ""}} {{ Invoice?Invoice.paid.toLocaleString():0}}</h5>
                </div>
                <div class="col-4 text-center">
                  <h5 class="m-0">Balance:  {{Invoice ? Invoice.business.currency.currency_code : ""}} {{ Invoice?(Invoice.total-Invoice.paid).toLocaleString():0}}</h5>
                </div>
              </div>
              <div class="row py-3">
                <div class="text-center">
                  <h5 v-if="ReceiptSettings.indicate_customerbalance == 1 && Invoice.customer.name">
                      <b>Total Balance Due:</b>
                      {{Invoice ? Invoice.business.currency.currency_code : ""}} {{ Invoice && Invoice.customer ? Invoice.customer.balance.toLocaleString() : "0" }}
                  </h5>
                </div>
              </div>
              <div style="border-top: 1px solid black;"></div>
              <div class="row py-3">
                <h5 class="text-center"><b>PAYMENTS CAN BE MADE BY: </b></h5>
                <table class="table font-size-15">
                <thead>
                  <tr>
                    <th>Account Type</th>
                    <th>OPERATING IN</th>
                    <th>Account Name</th>
                    <th>Account Number</th>
                    <th class="d-print-none">Show</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in PaymentOptions?PaymentOptions:'---'" :key="index">
                    <td v-if="item.showstatus == 1">{{item.type}}</td>
                    <td v-if="item.showstatus == 0" class="d-print-none">{{item.type}}</td>
                    <td v-if="item.showstatus == 1">{{item.type_name}}</td>
                    <td v-if="item.showstatus == 0" class="d-print-none">{{item.type_name}}</td>
                    <td v-if="item.showstatus == 1">{{item.name}}</td>
                    <td v-if="item.showstatus == 0" class="d-print-none">{{item.name}}</td>
                    <td v-if="item.showstatus == 1">{{item.anumber}}</td>
                    <td v-if="item.showstatus == 0" class="d-print-none">{{item.anumber}}</td>
                    <td class="d-print-none">
                      <div class="form-check form-switch form-switch-lg mb-3">                          
                        <input
                          v-if="item.showstatus==1"                              
                          @change="UpdateSetting(item.id,item.showstatus)"
                          class="form-check-input"
                          type="checkbox"
                          id="SwitchCheckSizelg"
                          checked
                        />
                        <input
                          v-else                              
                          @change="UpdateSetting(item.id,item.showstatus)"
                          class="form-check-input"
                          type="checkbox"
                          id="SwitchCheckSizelg"
                        />
                      </div>  
                    </td>
                  </tr>
                </tbody>
                </table>
              </div>
              <div style="border-top: 1px solid black;"></div>
              <div class="font-size-14 py-4 row">
                <div class="col-md-6">
                  <span>{{Invoice ? Invoice.business.tagline : ''}}</span>
                </div>
                <div class="col-md-6" align="right">
                  <strong>Prepared by:</strong> <span>{{Invoice ? Invoice.user : ''}}</span>
                </div>  
              </div>                          
            </div>
          </div>
        </div>
      </div>      
    </div>
    <!-- end row -->
  </Layout>
</template>